angular.module('v3sWbtPlayerApp').factory('v3sNavigationService', ["$state", "$rootScope", "v3sServiceFinder", function ($state, $rootScope, v3sServiceFinder) {

    var wbt = null;
    var testSco = null;
    var sco = null;
    var page = null;
    var previousPage = null;
    var nextPage = null;
    var previousPageState = null;
    var nextPageState = null;

    var v3sWbtDataService = null;

    var multiSco = false;
    var scoNavigationAllowed = false;

    var lastDirection = "";
    var lastPageId = "";

    function init(currentPage) {
        page = currentPage;
        sco = null;

        if (!!page) {
            sco = page.getSco();
            lastPageId = page.getId();
        }

        multiSco = v3sWbtDataService.isMultiSco();
        scoNavigationAllowed = v3sWbtDataService.isScoNavigationAllowed();

        updateNextPageState();
        updatePreviousPageState();
        notifyCurrentPageChanged(currentPage);
    };

    function initWbtData(_wbt, _v3sWbtDataService) {
        wbt = _wbt;
        v3sWbtDataService = _v3sWbtDataService;

        testSco = wbt.getTestSco();

        updateNextPageState();
        updatePreviousPageState();
        notifyWbtDataInited(wbt);
    };

    function getCurrentPage() {
        return page;
    };

    function getLastPageId() {
        return lastPageId;
    };

    function updateNextPageState() {
        var nextState = null;
        var newSco = null;

        if (!!page) {
            nextPage = page.getNext();

            if (nextPage !== "none" && nextPage != page) {
                if (!!nextPage) {
                    newSco = nextPage.getSco();
                }

                if (!!nextPage && (!multiSco || newSco === sco)) {
                    nextState = {
                        to: "main.sco", params: {
                            scoId: newSco.id, entry: nextPage.id
                        }
                    };
                } else if (multiSco && scoNavigationAllowed) { //multi sco navigation
                    if (!!newSco) {
                        nextState = {
                            to: "main.request", params: {
                                request: newSco.id, entry: nextPage.id
                            }
                        };
                    }
                }
            }
        }
        nextPageState = nextState;
    };

    function getNextPageState() {
        return nextPageState;
    };

    function getNextPage() {
        return nextPage;
    };

    function updatePreviousPageState() {
        var previousState = null;
        var newSco = null;

        if (!!page) {
            previousPage = page.getPrevious();

            if (previousPage !== "none" && previousPage != page) {
                if (!!previousPage) {
                    newSco = previousPage.getSco();
                }

                if (!!previousPage && (!multiSco || newSco === sco)) {
                    previousState = {
                        to: "main.sco", params: {
                            scoId: newSco.id, entry: previousPage.id
                        }
                    };
                } else if (!!multiSco && scoNavigationAllowed) { //multi sco navigation
                    if (!!newSco) {
                        previousState = {
                            to: "main.request", params: {
                                request: newSco.id, entry: previousPage.id
                            }
                        };
                    }
                }
            }
        }

        previousPageState = previousState;
    };

    function getPreviousPage() {
        return previousPage;
    };

    function getPreviousPageState() {
        return previousPageState;
    };

    function getHref(state) {
        var href = "";
        if (!!state) {
            href = $state.href(state.to, state.params);
        }
        return href;
    }

    function getPageState(item) {
        var state = null;

        while (!!item && !!item.sco && item.children == 0) {
            item = item.getNext();
        }

        if (!!item) {
            var newSco = item.getSco();
            if (!!newSco) {
                if (!multiSco || sco == newSco) {
                    state = { to: "main.sco", params: { scoId: newSco.id, entry: item.id } };
                } else if (scoNavigationAllowed) {
                    state = { to: "main.request", params: { request: newSco.id, entry: item.id } };
                }
            }
        }
        return state;
    };

    function goTo(state) {
        if (!!state && !!state.to){
            $state.go(state.to, state.params);
        }
    };

    function goToNext() {
        goTo(nextPageState);
        lastDirection = "next";
    };

    function goToPrevious() {
        goTo(previousPageState);
        lastDirection = "previous";
    };

    function getLastDirection() {
        return lastDirection;
    };

    function resetLastDirection() {
        lastDirection = "";
    };

    function getItem(itemStr) {
        var item = null;

        if (itemStr == "currentPage" || itemStr == "page") {
            item = page;
        } else if (itemStr == "currentSco" || itemStr == "sco") {
            item = sco;
        } else if (itemStr == "wbt") {
            item = wbt;
        } else if (itemStr == "test") {
            item = testSco;
        } else if (itemStr == "home") {
            item = wbt.getItemByTag(itemStr) || wbt.getFirstChild();
        } else {
            item = wbt.getItem(itemStr);
        }

        return item;
    };

    function getItems(itemStr) {
        var items = [];

        if (itemStr == "scos") {
            items = items.concat(wbt.getChildren());
        } else if (itemStr == "scos.firstPage") {
            angular.forEach(wbt.getChildren(), function (child) {
                items.push(child.getFirstChild());
            });
        } else if (itemStr == "scos.lastPage") {
            angular.forEach(wbt.getChildren(), function (child) {
                items.push(child.getLastChild());
            });
        } else if (itemStr == "sections") {
            items = items.concat(wbt.getItemsByType(v3sServiceFinder.get("v3sSection")));
        } else if (itemStr == "sections.firstPage") {
            var sections = wbt.getItemsByType(v3sServiceFinder.get("v3sSection"));
            angular.forEach(sections, function (section) {
                items.push(section.getFirstChild());
            });
        } else if (itemStr == "sections.lastPage") {
            var sections = wbt.getItemsByType(v3sServiceFinder.get("v3sSection"));
            angular.forEach(sections, function (section) {
                items.push(section.getLastChild());
            });
        } else if (itemStr == "sections.firstExercise") {
            var sections = wbt.getItemsByType(v3sServiceFinder.get("v3sSection"));
            angular.forEach(sections, function (section) {
                var pushed = false;
                angular.forEach(section.getChildren(), function (child) {
                    if (!pushed && child.isExercise()) {
                        items.push(child);
                        pushed = true;
                    }
                });
            });
        } else if (itemStr == "exercises") {
            var allItem = wbt.getItemsByType(v3sServiceFinder.get("v3sItem"));
            angular.forEach(allItem, function (item) {
                if (item.isExercise()) {
                    items.push(item);
                }
            });
        } else if (itemStr == "exercises.everySecond") {
            var allItem = wbt.getItemsByType(v3sServiceFinder.get("v3sItem"));
            var second = false;
            angular.forEach(allItem, function (item) {
                if (item.isExercise()) {
                    second = !second;
                    if (second) items.push(item);
                }
            });
        }else {
            items.push(getItem(itemStr));
        }

        return items;
    };

    function reload() {
        if (!!page) {
            var state = getPageState(page);
            state.params.readyToChange = true;
            //goTo(state);
            //Hier wird transitionTo verwendet, da bei goTo der Seitenwechsel animiert wird.
            $state.transitionTo(state.to, state.params, {
                reload: true, inherit: false, notify: true
            });
        }
    };

    function resetAndReload() {
        v3sWbtDataService.reset();
        location.reload();
    };

    function subscribeCurrentPageChanged(callback) {
        var handler = $rootScope.$on('v3sCurrentPageChanged', callback);
    }

    function notifyCurrentPageChanged(page) {
        $rootScope.$emit('v3sCurrentPageChanged', page);
    }

    function subscribeWbtDataInited(callback) {
        var handler = $rootScope.$on('v3sWbtDataInited', callback);
    }

    function notifyWbtDataInited(wbt) {
        $rootScope.$emit('v3sWbtDataInited', wbt);
    }

    return {
        init: init,
        initWbtData: initWbtData,
        getCurrentPage: getCurrentPage,
        getLastPageId: getLastPageId,
        getHref: getHref,
        getPageState: getPageState,
        getNextPage: getNextPage,
        getPreviousPage: getPreviousPage,
        getNextPageState: getNextPageState,
        getPreviousPageState: getPreviousPageState,
        goTo: goTo,
        goToNext: goToNext,
        goToPrevious: goToPrevious,
        getLastDirection: getLastDirection,
        resetLastDirection: resetLastDirection,
        getItem: getItem,
        getItems: getItems,
        reload: reload,
        resetAndReload: resetAndReload,
        subscribeCurrentPageChanged: subscribeCurrentPageChanged,
        subscribeWbtDataInited: subscribeWbtDataInited
    }
}]);
